import { ReactNode } from 'react';
import { useLogger } from '@packages/shared/core/common/hooks';
import { useQuizStep } from '@packages/shared/core/quiz/hooks';
import { QuizScreenProps, UserNameStepData } from '@packages/shared/core/quiz/entities';
import RenderOnlyOnClient from '@packages/shared/core/common/components/common/RenderOnlyOnClient';

type UserNameQuizStepProps = {
  id: string;
  renderQuizScreen: (stepData: QuizScreenProps) => ReactNode;
};

const UserNameQuizStep = ({ id, renderQuizScreen }: UserNameQuizStepProps) => {
  const logger = useLogger();
  const { back, next, stepData, updateUserPreferences, totalSteps, stepOrder } = useQuizStep(id);

  if (!stepData) {
    // TODO add fallback
    logger.error(new TypeError(`Data for ${id} step not found`));
    return null;
  }

  const { dataKey } = stepData as UserNameStepData;

  const goBack = async () => back();

  const onSubmit = async (text: string, key?: string) => {
    updateUserPreferences(dataKey, text);
    await next(text, key);
  };

  const onSkip = async () => {
    updateUserPreferences(dataKey, null);
    await next();
  };

  return (
    <>
      <RenderOnlyOnClient>
        {renderQuizScreen({
          onSubmit,
          onBack: goBack,
          onSkip,
          totalSteps,
          stepOrder,
          ...(stepData as UserNameStepData),
        })}
      </RenderOnlyOnClient>
    </>
  );
};

export default UserNameQuizStep;
